module.exports = __webpack_public_path__ + "static/img/shui_list.c1db9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/shui_list.png
// module id = 8YMs
// module chunks = 44